import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import {
  UpdateChildCategory,
  VirwChildCategory,
} from "../../../redux/services/ChildcategoriesService/Child_categories.Services";

import { ActiveCategoryList } from "../../../redux/services/categoriesService/categories.Services";
import { ActiveSubCategoryList } from "../../../redux/services/subCategoriesService/subCategories.Services";
import { ActiveUserList } from "../../../redux/services/User Services/User.Services";

import { successToast, errorToast } from "../../../Utils/toast";

import {
  closeProductModal,
  refreshProductList,
} from "../../../redux/features/productModalSlice";

function EditchildCategory({ data, onSuccess }) {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(false);
  const [errors, setErrors] = useState({});

  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [users, setUsers] = useState([]);

  const [formData, setFormData] = useState({
    category_id: "",
    sub_category_id: "",
    vendor_id: "",
    name: "",
    description: "",
    status: 1,
  });

  // ✅ Sequential fetch: Vendor → Category → SubCategory → ChildCategory
  useEffect(() => {
    const initFetch = async () => {
      setFetching(true);
      try {
        await fetchUsers();
        await fetchCategories();
        await fetchChildCategory();
      } catch (error) {
        console.log(error);
      } finally {
        setFetching(false);
      }
    };

    initFetch();
  }, [data]);

  const fetchUsers = async () => {
    try {
      const res = await ActiveUserList();
      if (res?.success) {
        setUsers(res.data || []);
      } else if (res?.data?.success) {
        setUsers(res.data.data || []);
      }
    } catch (error) {
      console.log(error);
      errorToast("Something went wrong");
    }
  };

  const fetchCategories = async () => {
    try {
      const res = await ActiveCategoryList();
      if (res?.success) {
        setCategories(res.data || []);
      } else if (res?.data?.success) {
        setCategories(res.data.data || []);
      }
    } catch (error) {
      console.log(error);
      errorToast("Something went wrong");
    }
  };

  // ✅ Fetch sub-categories by category id
  const fetchSubCategories = async (categoryId) => {
    try {
      const res = await ActiveSubCategoryList({
        category_id: categoryId,
      });

      if (res?.data?.success) {
        setSubCategories(res.data.data || []);
      } else if (res?.success) {
        setSubCategories(res.data || []);
      } else {
        setSubCategories([]);
      }
    } catch (error) {
      console.log(error);
      errorToast("Something went wrong");
    }
  };

  // ✅ Fetch child category details + pre-select values
 const fetchChildCategory = async () => {
  if (!data?.id) return;
  try {
    const res = await VirwChildCategory({ id: data.id });
    const category = res?.data || res;

    const catId =
      category?.sub_category_details?.category_id ||
      category?.category_id ||
      "";

    const subCatId =
      category?.subcategory_id ||
      category?.sub_category_id ||
      "";

    // ✅ user_id string use karo
    const vendorId =
      category?.vendor_details?.user_id ||
      category?.user_id ||
      "";

    if (catId) await fetchSubCategories(catId);

    setFormData({
      name: category?.name || "",
      description: category?.description || "",
      status: category?.status === 1 ? 1 : 0,
      category_id: catId ? String(catId) : "",
      sub_category_id: subCatId ? String(subCatId) : "",
      vendor_id: vendorId,   // ✅ already string
    });
  } catch (err) {
    console.log(err);
    errorToast(err?.response?.data?.message || "Error fetching child category");
  }
};

  // ✅ Handle change
  const handleChange = async (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "category_id" && {
        sub_category_id: "",
      }),
    }));

    if (name === "category_id") {
      if (value) {
        await fetchSubCategories(value);
      } else {
        setSubCategories([]);
      }
    }

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };

  // ✅ Validation
  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) {
      newErrors.name = ["Name is required"];
    }
    if (!formData.category_id) {
      newErrors.category_id = ["Please Select Category"];
    }
    if (!formData.sub_category_id) {
      newErrors.sub_category_id = ["Please Select SubCategory"];
    }
    if (!formData.vendor_id) {
      newErrors.vendor_id = ["Please Select Vendor"];
    }
    setErrors(newErrors);
    return newErrors;
  };

  // ✅ Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setTimeout(() => {
        const firstErrorField = document.querySelector(".is-invalid");
        if (firstErrorField) {
          firstErrorField.focus();
          firstErrorField.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }, 100);
      return;
    }

    try {
      setLoading(true);

      const payload = {
        id: data?.id,
        category_id: formData.category_id,
        vendor_id: formData.vendor_id,
        subcategory_id: formData.sub_category_id,
        name: formData.name,
        description: formData.description,
        status: formData.status,
      };

      const res = await UpdateChildCategory(payload);

      if (res?.success === true) {
        successToast(res?.message || "Updated successfully");
        if (onSuccess) await onSuccess();
        dispatch(refreshProductList());
        dispatch(closeProductModal());
      } else {
        errorToast(res?.data?.message || "Failed to update child category");
      }
    } catch (error) {
      console.error("Error updating child category:", error);

      if (error?.response?.status === 422) {
        setErrors(error.response.data.errors || {});
        errorToast("Validation Error", "Please check the form fields", "error");
      } else {
        errorToast(
          "Error",
          error?.response?.data?.message || "Something went wrong",
          "error"
        );
      }
    } finally {
      setLoading(false);
    }
  };

  if (fetching) {
    return (
      <div className="main_page text-center p-4">
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="main_page">
      <form onSubmit={handleSubmit} className="row g-3">
        {/* ✅ Vendor (User) Dropdown — Sabse pehle */}
        <div className="col-md-6">
          <label>
            Vendor <span className="text-danger">*</span>
          </label>
          <select
            className={`form-control ${errors?.vendor_id ? "is-invalid" : ""}`}
            name="vendor_id"
            value={formData.vendor_id}
            onChange={handleChange}
            disabled={loading}
          >
            <option value="">Select Vendor</option>
            {users.map((item) => (
              <option key={item.user_id} value={item.user_id}>
                {item.name || item.mobile || item.business_name || item.user_id}
              </option>
            ))}
          </select>
          {errors?.vendor_id && (
            <div className="invalid-feedback d-block">
              {errors.vendor_id[0]}
            </div>
          )}
        </div>

        {/* Category */}
        <div className="col-md-6">
          <label>
            Category <span className="text-danger">*</span>
          </label>
          <select
            className={`form-control ${errors?.category_id ? "is-invalid" : ""}`}
            name="category_id"
            value={formData.category_id}
            onChange={handleChange}
            disabled={loading}
          >
            <option value="">Select Category</option>
            {categories.map((item) => (
              <option key={item.id} value={item.id}>
                {item.name}
              </option>
            ))}
          </select>
          {errors?.category_id && (
            <div className="invalid-feedback d-block">
              {errors.category_id[0]}
            </div>
          )}
        </div>

        {/* Sub Category */}
        <div className="col-md-6">
          <label>
            Sub Category <span className="text-danger">*</span>
          </label>
          <select
            className={`form-control ${
              errors?.sub_category_id ? "is-invalid" : ""
            }`}
            name="sub_category_id"
            value={formData.sub_category_id}
            onChange={handleChange}
            disabled={loading || !formData.category_id}
          >
            <option value="">Select Sub Category</option>
            {subCategories.map((item) => (
              <option key={item.id} value={item.id}>
                {item.name}
              </option>
            ))}
          </select>
          {errors?.sub_category_id && (
            <div className="invalid-feedback d-block">
              {errors.sub_category_id[0]}
            </div>
          )}
        </div>

        {/* Name */}
        <div className="col-md-6">
          <label>
            Name <span className="text-danger">*</span>
          </label>
          <input
            placeholder="Child Category Name"
            className={`form-control ${errors?.name ? "is-invalid" : ""}`}
            value={formData.name}
            onChange={handleChange}
            name="name"
            disabled={loading}
          />
          {errors?.name && (
            <div className="invalid-feedback d-block">
              {Array.isArray(errors.name) ? errors.name[0] : errors.name}
            </div>
          )}
        </div>

        {/* Description */}
        <div className="col-md-12">
          <label>Description</label>
          <textarea
            name="description"
            rows="5"
            value={formData.description}
            onChange={handleChange}
            className="form-control"
            placeholder="Enter description..."
            disabled={loading}
          />
        </div>

        {/* Status */}
        <div className="col-md-12">
          <label>Status</label>
          <select
            className="form-control"
            name="status"
            value={formData.status}
            onChange={handleChange}
            disabled={loading}
          >
            <option value={1}>Active</option>
            <option value={0}>Inactive</option>
          </select>
        </div>

        <div className="col-md-12 text-end mt-2">
          <button className="add-btn" type="submit" disabled={loading}>
            {loading ? "Updating..." : "Update Child Category"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default EditchildCategory;